import { useObserver } from "mobx-react";
import TabSelector from "../JobPost/TabSelector";
import Technical from "./technical";
import { useStores } from "../../store";
import InterviewSettings from "../interview/InterviewSetting";
import InterviewPreview from "./InterviewPreview";
import { useLocation } from "react-router-dom";
import { AiOutlineLeft } from "react-icons/ai";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import { apiPostPut } from "../../api/api_methods";
import { useState } from "react";
import JobShare from "./Components/Job";
import Loader from "../reusble_components/loader";
import HrInterview from "./hrInterview";

export default function TechnicalInterview({ hr }) {
  const { CommonStore, RecuiterStore } = useStores();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = query.get("id"); // id of the interview3.
  const [invitationLink, setInvitationLink] = useState(null);
  const [clientLink, setClientLink] = useState(null);
  const [popUpVisible, setPopupVisible] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loader, setLoader] = useState(false);

  const link = () => {
    if (!invitationLink || !clientLink) {
      return {
        jobPostLink: "Interview link not available yet",
        clientLink: "Interview link not available yet",
      };
    }
    const jobPostLink = invitationLink;
    return { jobPostLink: jobPostLink, clientLink: clientLink };
  };

  const handleSubmit = async () => {
    const body = {
      interviewer: JSON.parse(localStorage.getItem("user"))?._id || "",
      model: 3,
      isInvitation: true,
      interviewType: "real",
      technology: (hr
        ? RecuiterStore.jobPostDetails.hrInterviewDetails
        : RecuiterStore.jobPostDetails.technicalInterviewDetails
      ).technology,
      whoPay: RecuiterStore.jobPostDetails.customSettings.find(
        (setting) => setting.name === "candidatePay"
      ).value
        ? "candidate"
        : "company",
      interviewId: (hr
        ? RecuiterStore.jobPostDetails.hrInterviewDetails
        : RecuiterStore.jobPostDetails.technicalInterviewDetails
      ).interviewId,
      levelOfInterview: hr
        ? RecuiterStore.jobPostDetails.hrInterviewDetails.interviewLevel ||
          "low"
        : RecuiterStore.jobPostDetails.technicalInterviewDetails
            .technicalInterviewLevel || "low",
      noOfQuestions: Number(
        hr
          ? RecuiterStore.jobPostDetails.hrInterviewDetails.numberOfQuestions
          : RecuiterStore.jobPostDetails.technicalInterviewDetails
              .technicalNumberOfQuestions
      ),
      noOfFollowUps: Number(
        hr
          ? RecuiterStore.jobPostDetails.hrInterviewDetails.noOfFollowUps
          : RecuiterStore.jobPostDetails.technicalInterviewDetails.noOfFollowUps
      ),
      noOfIntroQuestions: Number(
        hr
          ? RecuiterStore.jobPostDetails.hrInterviewDetails.noOfIntroQuestions
          : RecuiterStore.jobPostDetails.technicalInterviewDetails
              .noOfIntroQuestions
      ),
      noOfCustomQuestions: Number(
        hr
          ? RecuiterStore.jobPostDetails.hrInterviewDetails
              .noOfCustomQuestions || 0
          : RecuiterStore.jobPostDetails.technicalInterviewDetails
              .noOfCustomQuestions || 0
      ),
      allQuestions: Number(
        hr
          ? RecuiterStore.jobPostDetails.hrInterviewDetails.allQuestions
          : RecuiterStore.jobPostDetails.technicalInterviewDetails.allQuestions
      ),
      customQuestions: hr
        ? RecuiterStore.jobPostDetails.hrInterviewDetails.customquestions
        : RecuiterStore.jobPostDetails.technicalInterviewDetails
            .technicalCustomquestions,
      cutOff: (hr
        ? RecuiterStore.jobPostDetails.hrInterviewDetails
        : RecuiterStore.jobPostDetails.technicalInterviewDetails
      ).resumeCutoff,
      customSettings: [
        ...RecuiterStore.jobPostDetails.customSettings,
        // {
        //   name: "attempts",
        //   value: (hr
        //     ? RecuiterStore.jobPostDetails.hrInterviewDetails
        //     : RecuiterStore.jobPostDetails.technicalInterviewDetails
        //   ).additionalSettings.attempts,
        // },
      ],
    };
    let apiResponse;
    setLoader(true);
    if (id) {
      apiResponse = await apiPostPut(
        body,
        `/interview/update-interview/${id}`,
        "PUT"
      );
    } else {
      apiResponse = await apiPostPut(
        body,
        "/interview/interview-invitation",
        "POST"
      );
    }
    setLoader(false);
    if (apiResponse.body?.success) {
      CommonStore.setProgress(0);
      alert("Interview-invitation created successfully");

      const interviewId = hr ? 8 : 11;

      setInvitationLink(
        `${
          getDomainForWhiteLabeling() === "app.reaidy.io"
            ? `https://user.reaidy.io/interview-creation/${interviewId}?meetingid=${apiResponse.body?.data?._id}`
            : `https://${getDomainForWhiteLabeling()}/share?page=interview_invitation&id=${
                apiResponse.body?.data?._id
              }`
        }`
      );
      setClientLink(
        `https://${getDomainForWhiteLabeling()}/share/applicants?id=${
          apiResponse.body?.data?._id
        }`
      );
      setPopupVisible(true);
    } else {
      alert(apiResponse?.body?.message);
    }
  };
  const handlePopUpVisible = (value) => {
    setPopupVisible(value);
  };

  return useObserver(() => (
    <div className="flex flex-col items-center  w-[100%] h-full p-4 space-y-4">
      <Loader loader={loader} />
      {invitationLink !== null && popUpVisible && (
        <JobShare
          link={link()}
          emailBody={`Here is the interview link : ${invitationLink}`}
          isEdit={id ? true : false}
          emailSubject={""}
          isPopupVisible={popUpVisible}
          handlePopUpVisible={handlePopUpVisible}
          interview={`${hr ? "HR" : "Technical"} Interview`}
        />
      )}
      <h1 className="text-primary text-xl font-semibold">
        Create {hr ? "HR" : "Technical"} Interview
      </h1>
      <span className="tc1:w-[75%] sm:w-[60%] -mr-[10%] ">
        <TabSelector interview={true} />
      </span>
      <span className="border-t-2 w-full flex flex-col justify-between items-center">
        {CommonStore.progress === 0 &&
          (hr ? (
            <HrInterview skip={false} interview={true} />
          ) : (
            <Technical skip={false} interview={true} buttonName={"Next"} />
          ))}
        {CommonStore.progress === 1 && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (
                RecuiterStore.jobPostDetails.customSettings.find(
                  (setting) => setting.name === "aiVoice"
                )?.value.length === 0
              ) {
                alert("Please select an audio option");
                return;
              }

              CommonStore.setProgress(2);
              CommonStore.setInterviewLabelActive(1, true);
            }}
          >
            <InterviewSettings />

            <div className="flex w-[90%] mx-[5%] justify-between items-center gap-4 mt-4 md:mb-0 lg:mb-0 mb-20">
              <button
                type="button"
                className="flex items-center text-primary gap-2 mt-2"
                onClick={() => {
                  CommonStore.setProgress(0);
                }}
              >
                <AiOutlineLeft /> Back
              </button>
              <PrimaryButton
                buttonName={"Next"}
                width="w-fit"
                type={"submit"}
                padding={10}
                rounded="lg"
              />
            </div>
          </form>
        )}
        {CommonStore.progress === 2 && (
          <InterviewPreview
            interviewtype={hr ? "HR Interview" : "Technical Interview"}
            companyLogo={JSON.parse(localStorage.getItem("user"))?.pic || ""}
            companyName={JSON.parse(localStorage.getItem("user"))?.name || ""}
            totalQuestions={
              hr
                ? RecuiterStore.jobPostDetails.hrInterviewDetails
                    .numberOfQuestions
                : RecuiterStore.jobPostDetails.technicalInterviewDetails
                    .technicalNumberOfQuestions
            }
            totalFollowupQuestions={
              hr
                ? RecuiterStore.jobPostDetails.hrInterviewDetails.noOfFollowUps
                : RecuiterStore.jobPostDetails.technicalInterviewDetails
                    .noOfFollowUps
            }
            cutOff={
              (hr
                ? RecuiterStore.jobPostDetails.hrInterviewDetails
                : RecuiterStore.jobPostDetails.technicalInterviewDetails
              ).resumeCutoff
            }
            technology={
              (hr
                ? RecuiterStore.jobPostDetails.hrInterviewDetails
                : RecuiterStore.jobPostDetails.technicalInterviewDetails
              ).technology
            }
            level={
              hr
                ? RecuiterStore.jobPostDetails.hrInterviewDetails.interviewLevel
                : RecuiterStore.jobPostDetails.technicalInterviewDetails
                    .technicalInterviewLevel
            }
            attributes={[
              {
                id: 1,
                name: "Questions",
                value: hr
                  ? RecuiterStore.jobPostDetails.hrInterviewDetails
                      .numberOfQuestions
                  : RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .technicalNumberOfQuestions,
                show: true,
              },
              {
                id: 2,
                name: "Cut Off",
                value:
                  (hr
                    ? RecuiterStore.jobPostDetails.hrInterviewDetails
                    : RecuiterStore.jobPostDetails.technicalInterviewDetails
                  ).resumeCutoff ?? "",
                show: true,
              },

              {
                id: 3,
                name: "Level",
                value: hr
                  ? RecuiterStore.jobPostDetails.hrInterviewDetails
                      .interviewLevel
                  : RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .technicalInterviewLevel,
                show:
                  RecuiterStore.jobPostDetails.hrInterviewDetails
                    .interviewType === "Manual HR interview" ||
                  RecuiterStore.jobPostDetails.technicalInterviewDetails
                    .technicalInterviewType === "Manual interview"
                    ? false
                    : true,
                // ||
                // (RecuiterStore.jobPostDetails.technicalInterviewDetails
                //   .technicalInterviewType === "Manual interview"
                //   ? false
                //   : true),
              },
            ]}
            handleClick={() => {
              handleSubmit();
            }}
          />
        )}
      </span>
    </div>
  ));
}
